import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "job-info"
}
const _hoisted_2 = { class: "job-info__header" }
const _hoisted_3 = { class: "job-info__header-left" }
const _hoisted_4 = { class: "job-info__status-block" }
const _hoisted_5 = { class: "job-info__status-content" }
const _hoisted_6 = { class: "job-info__field" }
const _hoisted_7 = { class: "job-info__field-value" }
const _hoisted_8 = { class: "job-info__field" }
const _hoisted_9 = { class: "job-info__field-value" }
const _hoisted_10 = { class: "job-info__field" }
const _hoisted_11 = { class: "job-info__field-value" }
const _hoisted_12 = {
  key: 0,
  class: "job-info__field"
}
const _hoisted_13 = { class: "job-info__field-value" }
const _hoisted_14 = {
  key: 1,
  class: "job-info__field"
}
const _hoisted_15 = { class: "job-info__field-value" }
const _hoisted_16 = { class: "job-info__field job-info__field--col" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "job-info__additions"
}
const _hoisted_19 = { class: "job-info__addition-date" }
const _hoisted_20 = {
  key: 1,
  class: "job-info__field job-info__field--col"
}
const _hoisted_21 = { class: "job-info__tags" }
const _hoisted_22 = {
  key: 2,
  class: "job-info__field job-info__field--col"
}
const _hoisted_23 = {
  key: 3,
  class: "job-info__field job-info__field--col"
}
const _hoisted_24 = { class: "job-info__field-name" }
const _hoisted_25 = { class: "job-info__header-right" }
const _hoisted_26 = { class: "job-info__add-lists" }
const _hoisted_27 = { class: "job-info__lists" }
const _hoisted_28 = { class: "job-info__lists-item-name" }

import { ref } from "vue";
import { useRoute } from "vue-router";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import { JobInfo } from "@/store/jobs";
import { JobsApi } from "@/ api/JobsApi";
import { JobStatus } from "@/models/etc/types";
import moment from "moment/moment";
import { AnalyticsApi } from "@/ api/AnalyticsApi";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import { AnalyticsListItem } from "@/store/clients";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import MainInfoListSelect from "../../listSelect/MainInfoListSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'JobInfoModal',
  setup(__props, { expose: __expose }) {

const route = useRoute();

const $modal = ref<typeof BaseModal | null>(null);
const isLoading = ref(false);
const jobInfo = ref<JobInfo | null>(null);

const getJobStatusBarColor = (status: JobStatus) => {
  switch (status) {
    case JobStatus.Standard:
      return "#9A9C9E";
    case JobStatus.Working:
      return "#86CED2";
    case JobStatus.WaitingForCheck:
      return "#FFE7AA";
    case JobStatus.Completed:
      return "#6DA279";
    case JobStatus.Lost:
      return "#EE966A";
  }
};

const $createEditFileModal = ref<typeof AppResizableDropdown | null>(null);

const closeAddJobDropdown = () => {
  $createEditFileModal.value?.close();
};

const updateAnalyticLists = async () => {
  if (!jobInfo.value) return;

  jobInfo.value.AnalyticsLists = (
    await AnalyticsApi.getListOfElement(jobInfo.value.Job.Id, 2)
  ).Lists;
};

const onDeleteList = async (list: AnalyticsListItem) => {
  if (!jobInfo.value) return;
  await AnalyticsApi.removeElementIntoList(list.Id, 2, jobInfo?.value?.Job.Id);
  jobInfo.value.AnalyticsLists.splice(
    jobInfo.value?.AnalyticsLists.findIndex(
      (listFile) => listFile.Id === list.Id,
    ),
    1,
  );
};

const formatAdditionDate = (date?: string | Date) => {
  if (!date) return "";
  return moment(date).format("HH:mm DD.MM.YY");
};

const formatDateTime = (date?: string | Date) => {
  if (!date) return "";
  return moment(date).format("HH:mm DD.MM.YYYY");
};

const onOpen = async (jobId: number) => {
  try {
    isLoading.value = true;
    $modal.value?.onOpen();
    jobInfo.value = await JobsApi.getJobInfo(jobId);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

__expose({ onOpen });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    loading: isLoading.value,
    title: "Информация о работе"
  }, {
    default: _withCtx(() => [
      (!isLoading.value && jobInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "job-info__status-stripe",
                    style: _normalizeStyle({
                backgroundColor: getJobStatusBarColor(jobInfo.value.Job.Status),
              })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "job-info__field-name" }, "Дата создания: ", -1)),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(formatDateTime(jobInfo.value.Job.CreateTime)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "job-info__field-name" }, "Создатель: ", -1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(jobInfo.value.Job.Creator?.Name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "job-info__field-name" }, "Исполнитель: ", -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(jobInfo.value.Job.Worker?.Name), 1)
                    ]),
                    (jobInfo.value.Job.ToDoDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "job-info__field-name" }, "Сделать до:", -1)),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(formatDateTime(jobInfo.value.Job.ToDoDate)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (jobInfo.value.Job.CompletionDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "job-info__field-name" }, "Завершена: ", -1)),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(formatDateTime(jobInfo.value.Job.CompletionDate)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "job-info__field-name" }, "Содержание работы:", -1)),
                  _createElementVNode("div", {
                    class: "job-info__field-message",
                    innerHTML: jobInfo.value.Job.Message
                  }, null, 8, _hoisted_17)
                ]),
                (jobInfo.value.Job.Additions?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobInfo.value.Job.Additions, (addition, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "job-info__addition"
                        }, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(formatAdditionDate(addition.Date)), 1),
                          _createTextVNode(" [" + _toDisplayString(addition.Username) + "] " + _toDisplayString(addition.Title) + " " + _toDisplayString(addition.Message), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (jobInfo.value.Job.Tags?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "job-info__field-name" }, "Теги:", -1)),
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobInfo.value.Job.Tags, (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.Id,
                            class: "job-info__tag"
                          }, " #" + _toDisplayString(tag.Name?.toLowerCase()), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (jobInfo.value.Job.Project)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "job-info__field-name" }, "Проект:", -1)),
                      _createVNode(_component_router_link, {
                        class: "job-info__link",
                        to: {
                query: {
                  page: 'project',
                  id: jobInfo.value.Job.Project.Id,
                },
              },
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($modal.value?.onClose()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(jobInfo.value.Job.Project.Name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                (jobInfo.value.Job.Clients?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(jobInfo.value.Job.Clients.length === 1 ? "Клиент:" : "Клиенты:"), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobInfo.value.Job.Clients, (client) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: client.Id,
                          class: "job-info__link",
                          to: {
                query: {
                  page: 'client',
                  id: client.Id,
                },
              },
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($modal.value?.onClose()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(client.Name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(AppResizableDropdown, {
                    position: "left",
                    resizable: false,
                    "initial-width": 320,
                    "initial-height": 436,
                    "close-by-click-outside": false,
                    ref_key: "$createEditFileModal",
                    ref: $createEditFileModal,
                    name: "$createFileModal"
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppTooltip, { text: "Добавить в список" }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "job-info__add-lists-btn",
                            name: "plus",
                            width: "14px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(MainInfoListSelect, {
                        id: jobInfo.value?.Job.Id,
                        "added-lists": jobInfo.value?.AnalyticsLists,
                        "show-close-icon": "",
                        "entity-type": 2,
                        onClose: closeAddJobDropdown,
                        onAddList: updateAnalyticLists
                      }, null, 8, ["id", "added-lists"])
                    ]),
                    _: 1
                  }, 512),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "job-info__add-lists-text" }, "Списки:", -1))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobInfo.value?.AnalyticsLists, (list) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "job-info__lists-item",
                      key: list.Id
                    }, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(list.Name), 1),
                      _createVNode(AppIcon, {
                        class: "job-info__lists-item-delete",
                        name: "close",
                        width: "12px",
                        color: "#D2D2D2",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: ($event: any) => (onDeleteList(list))
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})